import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL?.replace(/\/api\/?$/, '') || 'http://localhost:5001';

const SendOffers = () => {
    const [offers, setOffers] = useState([]);
    const [groups, setGroups] = useState([]);
    const [selectedOffers, setSelectedOffers] = useState([]);
    const [selectedGroups, setSelectedGroups] = useState([]);
    const [delay, setDelay] = useState(4000);
    const [customMessage, setCustomMessage] = useState('🔥 OFERTA IMPERDÍVEL! 🔥');
    const [loading, setLoading] = useState(true);
    const [sending, setSending] = useState(false);
    const [sendResult, setSendResult] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const [offersRes, groupsRes] = await Promise.all([
                axios.get(`${API_URL}/api/ofertas`),
                axios.get(`${API_URL}/api/whatsapp/groups`)
            ]);
            setOffers(offersRes.data);
            setGroups(groupsRes.data);
            setLoading(false);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            alert('Erro ao carregar dados');
            setLoading(false);
        }
    };

    const toggleOffer = (offerId) => {
        setSelectedOffers(prev =>
            prev.includes(offerId)
                ? prev.filter(id => id !== offerId)
                : [...prev, offerId]
        );
    };

    const toggleGroup = (groupId) => {
        setSelectedGroups(prev =>
            prev.includes(groupId)
                ? prev.filter(id => id !== groupId)
                : [...prev, groupId]
        );
    };

    const handleSend = async () => {
        if (selectedOffers.length === 0) {
            alert('Selecione pelo menos uma oferta');
            return;
        }
        if (selectedGroups.length === 0) {
            alert('Selecione pelo menos um grupo');
            return;
        }

        const confirmMessage = `Enviar ${selectedOffers.length} oferta(s) para ${selectedGroups.length} grupo(s)?\n\nTotal de mensagens: ${selectedOffers.length * selectedGroups.length}`;

        if (!window.confirm(confirmMessage)) {
            return;
        }

        setSending(true);
        setSendResult(null);

        try {
            // Filtrar as ofertas completas com base nos IDs selecionados
            const offersToSend = offers.filter(offer => selectedOffers.includes(offer.id));

            const response = await axios.post(`${API_URL}/api/whatsapp/send-offers`, {
                offers: offersToSend,
                groupIds: selectedGroups,
                delay: delay,
                customMessage: customMessage
            });

            setSendResult(response.data);

            if (response.data.queuedCount !== undefined) {
                alert(`✅ ${response.data.message}\n\nAs mensagens serão enviadas em segundo plano com intervalos de segurança.`);
            } else {
                alert(`Envio concluído!\n✅ Sucesso: ${response.data.totalSent}\n❌ Falhas: ${response.data.totalFailed}`);
            }

            // Limpar seleções
            setSelectedOffers([]);
            setSelectedGroups([]);
        } catch (error) {
            console.error('Erro ao enviar:', error);
            alert('Erro ao enviar ofertas: ' + (error.response?.data?.error || error.message));
        } finally {
            setSending(false);
        }
    };

    if (loading) {
        return <div style={{ padding: '20px' }}>Carregando...</div>;
    }

    return (
        <div>
            <div className="card-header" style={{ marginBottom: '20px' }}>
                <h3><i className="fas fa-paper-plane"></i> Enviar Ofertas em Massa</h3>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px' }}>
                {/* Seleção de Ofertas */}
                <div style={{ border: '2px solid var(--primary-color)', borderRadius: '8px', padding: '20px', minWidth: 0 }}>
                    <div style={{ marginBottom: '15px' }}>
                        <div style={{ position: 'relative' }}>
                            <i className="fas fa-search" style={{
                                position: 'absolute',
                                left: '12px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                color: '#999'
                            }}></i>
                            <input
                                type="text"
                                placeholder="Pesquisar oferta pelo título..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                style={{
                                    width: '100%',
                                    display: 'block',
                                    padding: '10px 10px 10px 35px',
                                    borderRadius: '6px',
                                    border: '1px solid #ddd',
                                    fontSize: '0.9rem',
                                    outline: 'none',
                                    boxSizing: 'border-box',
                                    transition: 'border-color 0.2s'
                                }}
                            />
                        </div>
                    </div>

                    <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                        {offers
                            .filter(offer =>
                                offer.titulo?.toLowerCase().includes(searchTerm.toLowerCase())
                            )
                            .map((offer) => (
                                <div
                                    key={offer.id}
                                    onClick={() => toggleOffer(offer.id)}
                                    style={{
                                        padding: '12px',
                                        marginBottom: '8px',
                                        border: selectedOffers.includes(offer.id) ? '2px solid var(--primary-color)' : '1px solid #e0e0e0',
                                        borderRadius: '6px',
                                        cursor: 'pointer',
                                        backgroundColor: selectedOffers.includes(offer.id) ? 'rgba(255, 230, 0, 0.1)' : 'white',
                                        transition: 'all 0.2s'
                                    }}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                        <input
                                            type="checkbox"
                                            checked={selectedOffers.includes(offer.id)}
                                            onChange={() => { }}
                                            style={{ width: '18px', height: '18px' }}
                                        />
                                        
                                        {/* Thumbnail Miniatura */}
                                        <div style={{
                                            width: '50px',
                                            height: '50px',
                                            borderRadius: '4px',
                                            overflow: 'hidden',
                                            backgroundColor: '#f5f5f5',
                                            flexShrink: 0,
                                            border: '1px solid #eee'
                                        }}>
                                            <img
                                                src={offer.imagem_url || offer.imagem || 'https://via.placeholder.com/50'}
                                                alt=""
                                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                onError={(e) => { e.target.src = 'https://via.placeholder.com/50?text=📦'; }}
                                            />
                                        </div>

                                        <div style={{ flex: 1 }}>
                                            <div style={{ fontWeight: '600', fontSize: '0.95rem', lineHeight: '1.2' }}>{offer.titulo}</div>
                                            <div style={{ fontSize: '0.85rem', color: '#666', marginTop: '4px' }}>
                                                {offer.loja} • R$ {offer.precoFinal?.toFixed(2)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        {offers.filter(offer => offer.titulo?.toLowerCase().includes(searchTerm.toLowerCase())).length === 0 && (
                            <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
                                Nenhuma oferta encontrada para "{searchTerm}"
                            </div>
                        )}
                    </div>
                </div>

                {/* Seleção de Grupos */}
                <div style={{ border: '2px solid var(--accent-color)', borderRadius: '8px', padding: '20px' }}>
                    <h4 style={{ marginTop: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span><i className="fas fa-users"></i> Grupos ({selectedGroups.length} selecionados)</span>
                        {selectedGroups.length > 0 && (
                            <button
                                onClick={() => setSelectedGroups([])}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    color: '#dc3545',
                                    cursor: 'pointer',
                                    fontSize: '0.9rem'
                                }}
                            >
                                Limpar
                            </button>
                        )}
                    </h4>

                    <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                        {groups.map((group) => (
                            <div
                                key={group.id}
                                onClick={() => toggleGroup(group.id)}
                                style={{
                                    padding: '12px',
                                    marginBottom: '8px',
                                    border: selectedGroups.includes(group.id) ? '2px solid var(--accent-color)' : '1px solid #e0e0e0',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    backgroundColor: selectedGroups.includes(group.id) ? 'rgba(52, 131, 250, 0.1)' : 'white',
                                    transition: 'all 0.2s'
                                }}
                            >
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <input
                                        type="checkbox"
                                        checked={selectedGroups.includes(group.id)}
                                        onChange={() => { }}
                                        style={{ width: '18px', height: '18px' }}
                                    />
                                    <div style={{ flex: 1 }}>
                                        <div style={{ fontWeight: '600', fontSize: '0.95rem' }}>{group.name}</div>
                                        <div style={{ fontSize: '0.85rem', color: '#666' }}>
                                            {group.participantCount} participantes
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Configurações e Envio */}
            <div style={{
                backgroundColor: '#f8f9fa',
                padding: '20px',
                borderRadius: '8px',
                border: '1px solid #e0e0e0'
            }}>
                <h4 style={{ marginTop: 0 }}><i className="fas fa-cog"></i> Configurações de Envio</h4>

                <div className="form-group" style={{ marginBottom: '20px' }}>
                    <label>Mensagem de Destaque (Texto Customizável)</label>
                    <input
                        type="text"
                        value={customMessage}
                        onChange={(e) => setCustomMessage(e.target.value)}
                        placeholder="Ex: 🔥 OFERTA IMPERDÍVEL! 🔥"
                        className="form-control"
                        style={{ padding: '10px', width: '100%', maxWidth: '500px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '1rem' }}
                    />
                    <small style={{ color: '#666', display: 'block', marginTop: '5px' }}>
                        Este texto aparecerá no início da mensagem. Você pode usar emojis!
                    </small>
                </div>

                <div className="form-group" style={{ marginBottom: '20px' }}>
                    <label>Delay entre envios (milissegundos)</label>
                    <input
                        type="number"
                        value={delay}
                        onChange={(e) => setDelay(parseInt(e.target.value))}
                        min="1000"
                        max="10000"
                        step="500"
                        className="form-control"
                        style={{ padding: '10px', width: '200px', border: '1px solid #ddd', borderRadius: '4px' }}
                    />
                    <small style={{ color: '#666', display: 'block', marginTop: '5px' }}>
                        Recomendado: 3000-5000ms para evitar bloqueio
                    </small>
                </div>

                <div style={{
                    backgroundColor: 'white',
                    padding: '15px',
                    borderRadius: '6px',
                    marginBottom: '20px'
                }}>
                    <h5 style={{ margin: '0 0 10px 0' }}>Resumo do Envio:</h5>
                    <p style={{ margin: '5px 0' }}>
                        📱 <strong>{selectedOffers.length}</strong> oferta(s) selecionada(s)
                    </p>
                    <p style={{ margin: '5px 0' }}>
                        👥 <strong>{selectedGroups.length}</strong> grupo(s) selecionado(s)
                    </p>
                    <p style={{ margin: '5px 0' }}>
                        📨 Total de mensagens: <strong>{selectedOffers.length * selectedGroups.length}</strong>
                    </p>
                    <p style={{ margin: '5px 0', fontSize: '0.9rem', color: '#666' }}>
                        ⏱️ Tempo estimado: ~{Math.ceil((selectedOffers.length * selectedGroups.length * delay) / 1000)}s
                    </p>
                </div>

                <button
                    className="btn-primary"
                    onClick={handleSend}
                    disabled={sending || selectedOffers.length === 0 || selectedGroups.length === 0}
                    style={{
                        width: '100%',
                        padding: '12px',
                        fontSize: '1rem',
                        opacity: (sending || selectedOffers.length === 0 || selectedGroups.length === 0) ? 0.5 : 1
                    }}
                >
                    {sending ? (
                        <>
                            <i className="fas fa-spinner fa-spin"></i> Enviando...
                        </>
                    ) : (
                        <>
                            <i className="fas fa-paper-plane"></i> Enviar para Grupos Selecionados
                        </>
                    )}
                </button>
            </div>

            {/* Resultado do Envio */}
            {sendResult && (
                <div style={{
                    marginTop: '20px',
                    padding: '20px',
                    backgroundColor: sendResult.totalFailed === 0 ? '#d4edda' : '#fff3cd',
                    border: `1px solid ${sendResult.totalFailed === 0 ? '#c3e6cb' : '#ffeaa7'}`,
                    borderRadius: '8px'
                }}>
                    <h4 style={{ marginTop: 0 }}>
                        <i className="fas fa-check-circle"></i> Resultado do Envio
                    </h4>
                    <p>✅ Enviadas com sucesso: <strong>{sendResult.totalSent}</strong></p>
                    <p>❌ Falhas: <strong>{sendResult.totalFailed}</strong></p>
                </div>
            )}
        </div>
    );
};

export default SendOffers;
